export default {
    "types": {
        "required": {
            "showName": "Обязательные цели"
        }
    },
    "use_scales_units_library": true,
    "element_change_propagation_mode": 2,
    "folder_moderators_config_enabled": false,
    "folder_visibility_config_enabled": true,
    "folder_visibility_config_mode": 1,
    "folder_visibility_config_see_child": true,
    "on_import_using_visible": true,
    "on_folder_clone_clear_fields": [
        "bonus"
    ],
    "elements_sort_params": {
        "attributes": {
            "0": "id",
            "1": "name",
            "2": "desc",
            "category": {
                "asc": {
                    "expression": "CASE scale_general.category WHEN 1 THEN 'Финансы' WHEN 2 THEN 'Производство' WHEN 3 THEN 'Качество' WHEN 4 THEN 'Охрана труда' WHEN 5 THEN 'Преемственность' WHEN 6 THEN 'Проекты' WHEN 8 THEN 'Персонал' WHEN 9 THEN 'Бережливое производство' WHEN 7 THEN 'Другое' END ASC",
                    "params": []
                },
                "desc": {
                    "expression": "CASE scale_general.category WHEN 1 THEN 'Финансы' WHEN 2 THEN 'Производство' WHEN 3 THEN 'Качество' WHEN 4 THEN 'Охрана труда' WHEN 5 THEN 'Преемственность' WHEN 6 THEN 'Проекты' WHEN 8 THEN 'Персонал' WHEN 9 THEN 'Бережливое производство' WHEN 7 THEN 'Другое' END DESC",
                    "params": []
                }
            }
        },
        "joins": [
            [
                "inner join",
                "scale_general",
                "scale_general.id = scale_id"
            ]
        ],
        "defaultOrder": {
            "category": 4
        }
    },
    "elements_table_columns": [
        {
            "label": "ID",
            "prop": "id",
            "width": 60
        },
        {
            "label": "Категория",
            "prop": "category",
            "width": 140,
            "template": "componentsCompany/smz/tableColumnTemplates/card/ElementCategoryTableColumn",
            "bind": {
                "scope": "scope"
            }
        },
        {
            "label": "Название",
            "prop": "name",
            "template": "components/tableColumnTemplates/library/ElementNameTableColumn",
            "bind": {
                "scope": "scope",
                "show-folders-in-search": "templateData.$parent.$parent.$data.showFoldersInSearch"
            }
        },
        {
            "label": "Описание",
            "prop": "desc",
            "bind": {
                "scope": "scope"
            }
        },
        {
            "label": "Целевой уровень",
            "template": "componentsCompany/smz/tableColumnTemplates/card/ElementTargetTableColumn",
            "bind": {
                "scope": "scope"
            }
        },
        {
            "label": "Единица измерения",
            "prop": "scale.unit.name",
            "bind": {
                "scope": "scope"
            },
            "width": 110
        },
        {
            "label": "Целевой срок достижения",
            "width": 140,
            "template": "componentsCompany/smz/tableColumnTemplates/card/ElementDeadlineTableColumn",
            "bind": {
                "scope": "scope"
            }
        }
    ]
}